import React from "react";
import { cn } from "./cn";

const TONE = {
  default: "bg-bg-subtle text-ink-muted border border-border-strong",
  brand:   "bg-brand-50 text-brand-700 border border-brand-100",
  success: "bg-emerald-50 text-emerald-700 border border-emerald-100",
  warning: "bg-amber-50 text-amber-800 border border-amber-100",
  danger:  "bg-red-50 text-red-700 border border-red-100",
  ghost:   "bg-bg text-ink-muted border border-border",
};

const SIZE = {
  xs: "text-[10px] px-1.5 h-5",
  sm: "text-xs px-2 h-6",
  md: "text-sm px-2.5 h-7",
};

export function Badge({ tone = "default", size = "sm", className, children, ...rest }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full font-medium leading-none",
        TONE[tone],
        SIZE[size],
        className
      )}
      {...rest}
    >
      {children}
    </span>
  );
}

export function Dot({ tone = "default", className, ...rest }) {
  const map = {
    default: "bg-ink-subtle",
    success: "bg-success-500",
    warning: "bg-warning-500",
    danger:  "bg-danger-500",
    brand:   "bg-brand-500",
  };
  return (
    <span
      className={cn(
        "inline-block h-2 w-2 rounded-full",
        map[tone] || map.default,
        className
      )}
      {...rest}
    />
  );
}

export function Kbd({ className, children, ...rest }) {
  return (
    <kbd
      className={cn(
        "inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5",
        "rounded border border-border bg-white",
        "font-mono text-[10px] uppercase text-ink-muted",
        className
      )}
      {...rest}
    >
      {children}
    </kbd>
  );
}
